import { Core, Layer, Toaster } from '@acin/ui-core';
import { AuthProvider } from '@acin/user-accounts';
import { ApolloProvider } from '@apollo/client';
import { createAuth0Client } from '@auth0/auth0-spa-js';
import React from 'react';
import ReactDOM from 'react-dom';
import { getClient } from './apollo';
import { App } from './App';
import { config, datadogInit } from './auth0';
import { ORIGIN_URL_KEY } from './auth0/checkPathAndStoreOrigin';
import { onAuthenticated } from './auth0/onAuthenticated';
import * as serviceWorker from './serviceWorker';

const renderApp = async () => {
  const auth0 = await createAuth0Client(config);
  const client = await getClient(auth0);
  datadogInit();

  ReactDOM.render(
    <ApolloProvider client={client}>
      <AuthProvider originUrlKey={ORIGIN_URL_KEY} authClient={auth0} onAuthenticated={onAuthenticated}>
        <Core>
          <App />
          <Layer name="toaster">
            <Toaster />
          </Layer>
        </Core>
      </AuthProvider>
    </ApolloProvider>,
    document.getElementById('root'),
  );
};

renderApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
